/* Gaspard Charlevoix — comportamento do tema (carrinho lateral, pesquisa, menus, popup, contadores) */
(() => {
  const G = (window.GC = window.GC || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const T = G.t || {};

  // ---------- dinheiro ----------
  G.money = (cents) => {
    const fmt = G.moneyFormat || '{{amount_with_comma_separator}} $';
    const n = (cents || 0) / 100;
    const two = n.toFixed(2);
    const [i, d] = two.split('.');
    const milhar = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt
      .replace('{{amount_with_comma_separator}}', milhar(i, ' ') + ',' + d)
      .replace('{{amount_no_decimals_with_comma_separator}}', milhar(i, ' '))
      .replace('{{amount_no_decimals}}', milhar(i, ','))
      .replace('{{amount}}', milhar(i, ',') + '.' + d);
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (url, w) => (url ? url.replace(/(\.[a-z]+)(\?|$)/i, `$1$2`) + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  // ---------- abrir/fechar painéis ----------
  const lock = (on) => document.documentElement.style.overflow = on ? 'hidden' : '';
  G.open = (el) => { el.classList.add('is-open'); lock(true); };
  G.close = (el) => { el.classList.remove('is-open'); lock(false); };
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-gc-close]');
    if (c) { const p = c.closest('.gc-drawer, .gc-mnav, .gc-search, .gc-popup'); if (p) G.close(p); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.gc-drawer.is-open, .gc-mnav.is-open, .gc-search.is-open, .gc-popup.is-open').forEach(G.close);
  });

  // ---------- menu móvel e pesquisa ----------
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-gc-menu]')) { e.preventDefault(); G.open($('#gc-mnav')); }
    if (e.target.closest('[data-gc-search]')) { e.preventDefault(); const s = $('#gc-search'); G.open(s); setTimeout(() => $('input', s).focus(), 200); }
  });
  let tBusca;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('#gc-search input')) return;
    clearTimeout(tBusca);
    const q = e.target.value.trim();
    const res = $('#gc-search .gc-search__res');
    if (q.length < 2) { res.innerHTML = ''; return; }
    tBusca = setTimeout(async () => {
      const r = await fetch(`${G.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`);
      const d = await r.json();
      res.innerHTML = (d.resources.results.products || []).map((p) =>
        `<a href="${p.url}"><img src="${img(p.image, 300)}" alt="">${esc(p.title)}<br><b class="gc-price-new">${G.money(Math.round(parseFloat(p.price) * 100))}</b></a>`).join('');
    }, 250);
  });

  // ---------- carrinho ----------
  const drawer = () => $('#gc-drawer');
  let fimReserva = null;
  const reserva = () => {
    const k = 'gc-reserva';
    let fim = parseInt(sessionStorage.getItem(k) || '0', 10);
    if (!fim || fim < Date.now()) { fim = Date.now() + 10 * 60 * 1000; sessionStorage.setItem(k, String(fim)); }
    return fim;
  };
  setInterval(() => {
    const el = $('[data-gc-timer]');
    if (!el || !fimReserva) return;
    let s = Math.max(0, Math.round((fimReserva - Date.now()) / 1000));
    if (s === 0) { sessionStorage.removeItem('gc-reserva'); fimReserva = reserva(); s = 600; }
    el.textContent = `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  }, 1000);

  G.cart = null;
  G.compareMap = {};
  const vistos = {};
  async function precosRiscados() {
    // cart.js não traz o preço riscado: vai buscá-lo ao produto (uma vez por produto)
    await Promise.all(G.cart.items.filter((it) => !vistos[it.handle]).map(async (it) => {
      vistos[it.handle] = true;
      try {
        const p = await (await fetch(`${G.routes.root}products/${it.handle}.js`)).json();
        p.variants.forEach((v) => { if (v.compare_at_price) G.compareMap[v.id] = v.compare_at_price; });
      } catch (e) {}
    }));
  }
  G.refreshCart = async () => {
    G.cart = await (await fetch(`${G.routes.cart}.js`)).json();
    await precosRiscados();
    render();
    return G.cart;
  };
  const contagens = () => $$('[data-gc-count]').forEach((el) => { el.textContent = G.cart.item_count; el.dataset.n = G.cart.item_count; });

  function linha(it, i) {
    const old = it.original_price > it.final_price ? it.original_price : (it.compare_at_price || 0);
    const compare = it.properties && it.properties._compare ? parseInt(it.properties._compare, 10) : 0;
    const antes = Math.max(old, compare, G.compareMap[it.variant_id] || 0);
    const poupa = antes > it.final_price ? (antes - it.final_price) * it.quantity : 0;
    return `<div class="gc-line" data-line="${i + 1}">
      <a href="${it.url}"><img src="${img(it.image, 200)}" alt="${esc(it.product_title)}"></a>
      <div>
        <a class="gc-line__title" href="${it.url}">${esc(it.product_title)}</a>
        ${it.variant_title && !it.product_has_only_default_variant ? `<div class="gc-line__var">${esc(it.variant_title)}</div>` : ''}
        <div class="gc-line__price">${antes > it.final_price ? `<span class="gc-price-old">${G.money(antes)}</span>` : ''}<span class="gc-price-new">${G.money(it.final_price)}</span>
          ${poupa ? ` <span class="gc-line__save">(${T.save || 'Économisez'} ${G.money(poupa)})</span>` : ''}</div>
        <div class="gc-qty"><button type="button" data-q="-1" aria-label="-">−</button><input type="number" min="0" value="${it.quantity}" aria-label="Qté"><button type="button" data-q="1" aria-label="+">+</button></div>
      </div>
      <button class="gc-line__del" type="button" data-del aria-label="${T.remove || 'Retirer'}"><svg width="16" height="18" viewBox="0 0 16 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 4h14M6 4V2h4v2M3 4l1 13h8l1-13M6.5 7.5v6M9.5 7.5v6"/></svg></button>
    </div>`;
  }

  async function render() {
    const d = drawer();
    if (!d || !G.cart) return;
    contagens();
    const c = G.cart;
    $('[data-gc-drawer-count]', d).textContent = c.item_count;
    const body = $('.gc-drawer__body', d);
    const foot = $('.gc-drawer__foot', d);
    const hold = $('.gc-drawer__hold', d);
    if (!c.item_count) {
      hold.classList.add('gc-hidden'); foot.classList.add('gc-hidden');
      body.innerHTML = `<div class="gc-drawer__empty"><p>${T.empty || 'Votre panier est vide'}</p><a class="gc-btn" href="${G.routes.all}">${T.continue || 'Continuer vos achats'}</a></div>`;
      return;
    }
    hold.classList.remove('gc-hidden'); foot.classList.remove('gc-hidden');
    fimReserva = fimReserva || reserva();
    body.innerHTML = c.items.map(linha).join('') + '<div class="gc-upsell" data-gc-upsell></div>';
    $('[data-gc-total]', d).textContent = G.money(c.total_price);
    upsell(c.items[0].product_id);
  }

  let upsellLista = [], upsellIdx = 0;
  async function upsell(pid) {
    const box = $('[data-gc-upsell]');
    if (!box) return;
    try {
      const r = await fetch(`${G.routes.recs}.json?product_id=${pid}&limit=6&intent=related`);
      const d = await r.json();
      const noCarrinho = new Set(G.cart.items.map((i) => i.product_id));
      upsellLista = (d.products || []).filter((p) => !noCarrinho.has(p.id) && p.available);
    } catch (e) { upsellLista = []; }
    upsellIdx = 0;
    pintarUpsell();
  }
  function pintarUpsell() {
    const box = $('[data-gc-upsell]');
    if (!box || !upsellLista.length) { if (box) box.innerHTML = ''; return; }
    const p = upsellLista[upsellIdx % upsellLista.length];
    const v = p.variants.find((x) => x.available) || p.variants[0];
    const sel = p.variants.length > 1
      ? `<select data-upsell-var>${p.variants.map((x) => `<option value="${x.id}" ${x.available ? '' : 'disabled'}>${esc(x.title)}</option>`).join('')}</select>`
      : `<input type="hidden" data-upsell-var value="${v.id}">`;
    box.innerHTML = `<h4>${T.alsoLike || 'Vous aimerez aussi'}</h4>
      <div class="gc-upsell__card"><a href="${p.url}"><img src="${img(p.featured_image, 200)}" alt=""></a>
        <div style="min-width:0"><div class="gc-upsell__t">${esc(p.title)}</div>
        <div>${v.compare_at_price > v.price ? `<span class="gc-price-old">${G.money(v.compare_at_price)}</span>` : ''}${G.money(v.price)}</div>
        <div class="gc-upsell__row">${sel}<button type="button" data-upsell-add>${T.add || 'Ajouter'}</button></div></div></div>
      ${upsellLista.length > 1 ? '<div class="gc-upsell__nav"><button type="button" data-upsell-nav="-1">‹</button><button type="button" data-upsell-nav="1">›</button></div>' : ''}`;
  }

  G.add = async (items, abrir = true) => {
    const r = await fetch(`${G.routes.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); alertaErro(e.description || e.message); return false; }
    await G.refreshCart();
    if (abrir) G.open(drawer());
    return true;
  };
  function alertaErro(msg) {
    const n = document.createElement('div');
    n.textContent = msg || 'Erreur';
    n.style.cssText = 'position:fixed;left:50%;top:20px;transform:translateX(-50%);background:#b5002c;color:#fff;padding:10px 18px;z-index:200;font-size:13px';
    document.body.appendChild(n); setTimeout(() => n.remove(), 3500);
  }
  async function mudar(line, quantity) {
    const r = await fetch(`${G.routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    G.cart = await r.json(); await precosRiscados(); render();
  }

  document.addEventListener('click', async (e) => {
    const d = drawer();
    if (e.target.closest('[data-gc-cart]')) {
      if (location.pathname === G.routes.cart) return;
      e.preventDefault(); await G.refreshCart(); G.open(d); return;
    }
    const ln = e.target.closest('.gc-line');
    if (ln && e.target.closest('[data-q]')) {
      const inp = $('input', ln); mudar(+ln.dataset.line, Math.max(0, +inp.value + +e.target.closest('[data-q]').dataset.q));
    }
    if (ln && e.target.closest('[data-del]')) mudar(+ln.dataset.line, 0);
    if (e.target.closest('[data-upsell-nav]')) { upsellIdx = (upsellIdx + upsellLista.length + +e.target.closest('[data-upsell-nav]').dataset.upsellNav) % upsellLista.length; pintarUpsell(); }
    if (e.target.closest('[data-upsell-add]')) { const v = $('[data-upsell-var]', d).value; G.add([{ id: +v, quantity: 1 }]); }
  });
  document.addEventListener('change', (e) => {
    const ln = e.target.closest('.gc-line');
    if (ln && e.target.matches('input')) mudar(+ln.dataset.line, Math.max(0, +e.target.value));
  });

  // formulários de produto simples (cartões, página de produto)
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-gc-add]');
    if (!f) return;
    e.preventDefault();
    const btn = $('[type=submit]', f); if (btn) btn.disabled = true;
    const fd = new FormData(f);
    const ok = await G.add([{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }]);
    if (btn) btn.disabled = false;
    return ok;
  });

  // ---------- popup de desconto ----------
  function popup() {
    const p = $('#gc-popup');
    if (!p) return;
    try { if (localStorage.getItem('gc-popup')) return; } catch (e) {}
    setTimeout(() => G.open(p), 6000);
    p.addEventListener('click', (e) => {
      if (e.target.closest('[data-gc-close]')) { try { localStorage.setItem('gc-popup', '1'); } catch (er) {} }
    });
    $('form', p)?.addEventListener('submit', (e) => {
      e.preventDefault();
      try { localStorage.setItem('gc-popup', '1'); } catch (er) {}
      $('.gc-popup__body', p).innerHTML = `<h3>${T.thanks || 'Merci!'}</h3><p>${T.code || 'Votre code :'} <b style="font-size:18px">BIENVENUE10</b></p><button class="gc-popup__no" data-gc-close>${T.close || 'Fermer'}</button>`;
    });
  }

  // ---------- contadores e aparições ----------
  function contador(el) {
    const alvo = parseFloat(el.dataset.gcCount2), dur = 1600, t0 = performance.now();
    const passo = (t) => { const k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(alvo * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(passo); };
    requestAnimationFrame(passo);
  }
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => ents.forEach((en) => {
    if (!en.isIntersecting) return;
    io.unobserve(en.target);
    if (en.target.dataset.gcCount2) contador(en.target); else en.target.classList.add('is-in');
  }), { threshold: .2 }) : null;
  G.observe = (r = document) => $$('[data-gc-count2], .gc-appear', r).forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  // ---------- acordeões ----------
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-gc-acc]');
    if (!b) return;
    const item = b.parentElement;
    item.classList.toggle('is-open');
    b.setAttribute('aria-expanded', item.classList.contains('is-open'));
  });

  // ---------- carrosséis simples ----------
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-gc-slide]');
    if (!b) return;
    const trilho = $(b.dataset.target) || b.closest('[data-gc-slider]')?.querySelector('[data-gc-track]');
    if (!trilho) return;
    const card = trilho.firstElementChild;
    trilho.scrollBy({ left: (card ? card.getBoundingClientRect().width + 20 : 300) * +b.dataset.gcSlide, behavior: 'smooth' });
  });

  document.addEventListener('DOMContentLoaded', () => {
    G.observe();
    popup();
    G.refreshCart().catch(() => {});
  });
})();
